<template>
  <div class="primary">
    <v-row :style="`height:${frameHeight}px;`" class="mt-0 py-5 pb-12 primary align-center">
      <v-col cols="12" v-if="false" md="7" class="primary pa-0 d-none d-md-block">
        <v-img
          v-if="splash"
          :src="splash.url"
          :contain="splash.contain"
          :cover="splash.cover"
          :style="`height:${frameHeight}px;`"
        >
        </v-img>
      </v-col>
      
      <v-col cols="12" md="4" class="pa-0 elevation-0 align-center">
      </v-col>
      <v-col cols="12" md="4" :class="`${register_screen ? 'my-12' : 'my-12'} pa-2 py-12 elevation-0 align-center`">
        <v-card class="pa-2 elevation-2 ma-0" >
          <v-card class="text-center primary py-5 elevation-2 align-center">
            <img v-if="site.wlogo" :src="site.wlogo" width="110" alt="">
            <span v-if="!site.logo" class="headline white--text">{{site.name.toUpperCase()}}</span>
          </v-card>
          <v-card-text class="text-center" v-if="verify_screen">
            <v-alert v-if="!loading && verify_success" :class="`${arabic ? 'arFont' : ''}`" dark color="success">
              {{ i18n['your_email_has_been_verified_you_can_start_working'] }}
            </v-alert>
            <v-alert v-if="!loading && !verify_success" :class="`${arabic ? 'arFont' : ''}`" dark color="error">
              {{ i18n['your_email_verification_didnt_work_please_contact_support'] }}
            </v-alert>
            <v-btn v-if="!loading && verify_success" color="success" @click="goTo('/login')" :class="`${arabic ? 'arFont' : ''}`">{{ i18n['login'] }}</v-btn>
          </v-card-text>
          <v-card-text class="text-center" v-if="register_screen">
            <v-stepper v-model="register_step" class="elevation-0">
              <v-stepper-header class="elevation-0">
                <v-stepper-step
                  :complete="register_step > 1"
                  step="1"
                
                >
                  <span :class="`${arabic ? 'arFont' : ''} pr-1`">{{ i18n['information'] }}</span>
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step
                  :complete="register_step > 2"
                  step="2"
                  :class="`${arabic ? 'arFont' : ''} pr-1`"
                >
                  <span :class="`${arabic ? 'arFont' : ''} pr-1`">{{ i18n['register'] }}</span>
                </v-stepper-step>
              </v-stepper-header>

              <v-stepper-items>
                <v-stepper-content step="1" class="py-3">
                  <v-text-field 
                    append-icon="person" 
                    name="firstname" 
                    v-if="register_screen"
                    :label="i18n['first_name']" 
                    type="text" 
                    :class="`${arabic ? 'arFont' : 'enFont'}`"
                    v-model.trim="firstName">
                  </v-text-field>
                  <v-text-field 
                    append-icon="person" 
                    name="lastname" 
                    v-if="register_screen"
                    :label="i18n['last_name']" 
                    type="text" 
                    :class="`${arabic ? 'arFont' : 'enFont'}`"
                    v-model.trim="lastName">
                  </v-text-field>
                  <v-autocomplete
                    :label="i18n['residency_country']" 
                    :items="countries"
                    v-if="register_screen"
                    dense
                    item-text="name"
                    item-value="id"
                    :loading="loading"
                    :class="` specialInput ${arabic ? 'arFont' : 'enFont'}`"
                    v-model="user.country_id">
                    <template v-slot:selection="{ attr, on, item, selected }">
                      <span
                        v-bind="attr"
                        :input-value="selected"
                        v-on="on"
                        :class="`${arabic ? 'arFont' : 'enFont'}`"
                      >
                        <v-chip x-small>{{ item.name }}</v-chip>
                      </span>
                    </template>
                    <template v-slot:item="{ item }">
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`">
                        {{ item.name }}
                      </div>
                    </template>
                  </v-autocomplete>
                  <v-text-field 
                    append-icon="phone" 
                    name="phone" 
                    v-if="register_screen"
                    :label="i18n['your_phone_number_with_example']" 
                    type="text" 
                    :class="`${arabic ? 'arFont' : 'enFont'}`"
                    v-model.trim="user.phone">
                  </v-text-field>
                  <div :class="`${arabic ? 'arFont' : 'enFont'}`">
                    {{ i18n['phone_number_should_be_active_on_whatsapp'] }}
                  </div>
                  <v-checkbox 
                    :label="i18n['i_agree_to_terms_and_conditions']" 
                    :class="`${arabic ? 'arFont' : 'enFont'}`" 
                    v-if="register_screen"
                    v-model="terms" 
                    :value="true">
                  </v-checkbox>
                  <v-btn color="primary" v-if="register_screen" text small :class="`${arabic ? 'arFont' : 'enFont'}`" @click="goTo('/toc')">{{ i18n['terms_and_conditions'] }}</v-btn>
                  <div><span v-if="error" :class="`${arabic ? 'arFont' : ''} error--text py-2`">{{ error }}</span></div>
                  
                  <v-card-actions v-if="register_screen" NEW>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" v-if="!forgetpass" text large :loading="loading" 
                      @click="() => { login_screen = true; register_screen = false }"
                      :class="`${arabic ? 'arFont' : 'enFont'}`">
                      {{ i18n.login }}
                    </v-btn>
                    <v-btn color="primary" :disabled="!terms" v-if="!forgetpass" @click="submitBasicInfo()" large :loading="loading" 
                      :class="`${arabic ? 'arFont' : 'enFont'}`">
                      {{ i18n['next'] }}
                    </v-btn>
                  </v-card-actions>
                </v-stepper-content>

                <v-stepper-content step="2" class="py-1">
                  <v-btn
                    color="primary"
                    x-large
                    outlined

                    :class="`${arabic ? 'arFont' : ''} pr-1`"
                    @click="OauthLogin(0)"
                  >
                    <img src="/images/google.svg" width="18px" class="mx-2 mr-4">
                      {{ i18n['register_with_google'] }}
                  </v-btn>
                  <v-divider class="my-5"></v-divider>
                  <div :class="`${arabic ? 'arFont' : ''}`">{{ i18n['or_register_using'] }}:</div>
                  <v-text-field 
                    append-icon="email" 
                    name="email" 
                    :label="i18n.email" 
                    type="text" 
                    :class="`${arabic ? 'arFont' : 'enFont'}`"
                    v-model.trim="user.email">
                  </v-text-field>
                  <v-text-field 
                    v-if="!forgetpass"
                    append-icon="lock" 
                    name="password" 
                    :label="i18n.password" 
                    id="password" 
                    :class="`${arabic ? 'arFont' : 'enFont'}`"
                    type="password" 
                    v-model="user.password">
                  </v-text-field>
                  <v-text-field 
                    v-if="register_screen"
                    append-icon="lock" 
                    name="password" 
                    :label="i18n['confirm_password']" 
                    id="password" 
                    :class="`${arabic ? 'arFont' : 'enFont'}`"
                    type="password" 
                    v-model="repeatpassword">
                  </v-text-field>
                  <div><span v-if="error" :class="`${arabic ? 'arFont' : ''} error--text`">{{ error }}</span></div>

                  <v-card-actions>
                    <v-spacer></v-spacer>
              
                    <v-btn color="primary" v-if="!forgetpass" text large :loading="loading" 
                      @click="() => { login_screen = true; register_screen = false }"
                      :class="`${arabic ? 'arFont' : 'enFont'}`">
                      {{ i18n.login }}
                    </v-btn>
                    <v-btn color="primary" :disabled="!terms" v-if="!forgetpass" @click="register" large :loading="loading" 
                      :class="`${arabic ? 'arFont' : 'enFont'}`">
                      {{ i18n.register }}
                    </v-btn>
                  </v-card-actions>
                </v-stepper-content>
                
              </v-stepper-items>
            </v-stepper>
          </v-card-text>
          <v-card-text class="text-center" v-if="login_screen">
            <v-form>
              <v-btn
                color="primary"
                x-large
                outlined

                :class="`${arabic ? 'arFont' : ''} pr-1`"
                @click="OauthLogin(0)"
              >
                <img src="/images/google.svg" width="18px" class="mx-2 mr-4">
                  {{ i18n['login_with_google'] }}
              </v-btn>
              <v-divider class="my-5"></v-divider>
              <div :class="`${arabic ? 'arFont' : ''}`">{{ i18n['or_login_via'] }}:</div>
              <v-text-field 
                append-icon="email" 
                name="email" 
                :label="i18n.email" 
                type="text" 
                :class="`${arabic ? 'arFont' : 'enFont'}`"
                v-model.trim="user.email">
              </v-text-field>
              <v-text-field 
                v-if="!forgetpass"
                append-icon="lock" 
                name="password" 
                :label="i18n.password" 
                id="password" 
                :class="`${arabic ? 'arFont' : 'enFont'}`"
                type="password" 
                v-model="user.password">
              </v-text-field>
              <v-text-field 
                v-if="register_screen"
                append-icon="lock" 
                name="password" 
                :label="i18n['confirm_password']" 
                id="password" 
                :class="`${arabic ? 'arFont' : 'enFont'}`"
                type="password" 
                v-model="repeatpassword">
              </v-text-field>
              <span OLDF FIELDS v-if="false">
                <v-text-field 
                  append-icon="person" 
                  name="firstname" 
                  v-if="register_screen"
                  :label="i18n['first_name']" 
                  type="text" 
                  :class="`${arabic ? 'arFont' : 'enFont'}`"
                  v-model.trim="firstName">
                </v-text-field>
                <v-text-field 
                  append-icon="person" 
                  name="lastname" 
                  v-if="register_screen"
                  :label="i18n['last_name']" 
                  type="text" 
                  :class="`${arabic ? 'arFont' : 'enFont'}`"
                  v-model.trim="lastName">
                </v-text-field>
                <v-autocomplete
                  :label="i18n['residency_country']" 
                  :items="countries"
                  v-if="register_screen"
                  dense
                  item-text="name"
                  item-value="id"
                  :loading="loading"
                  :class="` specialInput ${arabic ? 'arFont' : 'enFont'}`"
                  v-model="user.country_id">
                  <template v-slot:selection="{ attr, on, item, selected }">
                    <span
                      v-bind="attr"
                      :input-value="selected"
                      v-on="on"
                      :class="`${arabic ? 'arFont' : 'enFont'}`"
                    >
                      <v-chip x-small>{{ item.name }}</v-chip>
                    </span>
                  </template>
                  <template v-slot:item="{ item }">
                    <div :class="`${arabic ? 'arFont' : 'enFont'}`">
                      {{ item.name }}
                    </div>
                  </template>
                </v-autocomplete>
                <v-text-field 
                  append-icon="phone" 
                  name="phone" 
                  v-if="register_screen"
                  :label="i18n['your_phone_number']" 
                  type="text" 
                  :class="`${arabic ? 'arFont' : 'enFont'}`"
                  v-model.trim="user.phone">
                </v-text-field>
                <v-text-field 
                  append-icon="phone" 
                  name="phone" 
                  v-if="register_screen"
                  :label="i18n['your_whatsapp_number']" 
                  type="text" 
                  :class="`${arabic?'arFont':'enFont'}`"
                  v-model.trim="user.whatsapp">
                </v-text-field>
                <v-text-field 
                  append-icon="link" 
                  name="facebook_account" 
                  v-if="register_screen"
                  :label="i18n['your_facebook_account_link']" 
                  type="text" 
                  :class="`${arabic?'arFont':'enFont'}`"
                  v-model.trim="user.facebook_link">
                </v-text-field>
                <v-autocomplete
                  :label="i18n['sold_countries_history']" 
                  multiple
                  item-value="name"
                  v-if="register_screen"
                  item-text="name"
                  :items="countries"
                  :class="`${arabic?'arFont':'enFont'}`"
                  v-model.trim="user.countries_history"
                >
                  <template v-slot:selection="{ attr, on, item, selected }">
                    <span
                      v-bind="attr"
                      :input-value="selected"
                      v-on="on"
                      :class="`${arabic?'arFont':'enFont'}`"
                    >
                      <v-chip x-small>{{item.name}}</v-chip>
                    </span>
                  </template>
                  <template v-slot:item="{ item }">
                    <div :class="`${arabic?'arFont':'enFont'}`">
                      {{item.name}}
                    </div>
                  </template>
                </v-autocomplete>  
                <v-select
                  :label="i18n['ads_used_before']" 
                  multiple
                  v-if="register_screen"
                  :items="ads"
                  :class="`${arabic?'arFont':'enFont'}`"
                  v-model.trim="user.ads"
                >
                  <template v-slot:selection="{ attr, on, item, selected }">
                    <span
                      v-bind="attr"
                      :input-value="selected"
                      v-on="on"
                      :class="`${arabic?'arFont':'enFont'}`"
                    >
                      <v-chip x-small>{{i18n[item]}}</v-chip>
                    </span>
                  </template>
                  <template v-slot:item="{ item }">
                    <div :class="`${arabic?'arFont':'enFont'}`">
                      {{i18n[item]}}
                    </div>
                  </template>
                </v-select>
                <v-select
                  :label="i18n['total_monthly_ads_spend']" 
                  v-if="register_screen"
                  :items="budgets"
                  :class="`${arabic?'arFont':'enFont'}`"
                  v-model.trim="user.current_budget"
                >
                  <template v-slot:selection="{ attr, on, item, selected }">
                    <span
                      v-bind="attr"
                      :input-value="selected"
                      v-on="on"
                      :class="`${arabic?'arFont':'enFont'}`"
                    >
                      <v-chip x-small>{{i18n[item]}}</v-chip>
                    </span>
                  </template>
                  <template v-slot:item="{ item }">
                    <div :class="`${arabic?'arFont':'enFont'}`">
                      {{i18n[item]}}
                    </div>
                  </template>
                </v-select>
                <v-select
                  :label="i18n['average_weekly_orders']" 
                  v-if="register_screen"
                  :items="sales"
                  :class="`${arabic?'arFont':'enFont'}`"
                  v-model.trim="user.sales"
                >
                  <template v-slot:selection="{ attr, on, item, selected }">
                    <span
                      v-bind="attr"
                      :input-value="selected"
                      v-on="on"
                      :class="`${arabic?'arFont':'enFont'}`"
                    >
                      <v-chip x-small>{{i18n[item]}}</v-chip>
                    </span>
                  </template>
                  <template v-slot:item="{ item }">
                    <div :class="`${arabic?'arFont':'enFont'}`">
                      {{i18n[item]}}
                    </div>
                  </template>
                </v-select>
                 <v-checkbox 
                  :label="i18n['i_agree_to_terms_and_conditions']"
                  :class="`${arabic ? 'arFont' : 'enFont'}`" 
                  v-if="register_screen"
                  v-model="terms" 
                  :value="true">
                </v-checkbox>
                <v-btn color="primary" v-if="register_screen" text small :class="`${arabic ? 'arFont' : 'enFont'}`" @click="goTo('/toc')">{{ i18n['terms_and_conditions'] }}</v-btn>
              </span>
            </v-form>
            <div><span v-if="error" :class="`${ arabic ? 'arFont' : '' } error--text`">{{ error }}</span></div>
          </v-card-text>
          <v-card-actions v-if="login_screen">
            <span v-if="!forgetpass" 
              @click="forgetpass  = true" 
              style="cursor:pointer;font-size:12px;"
              :class="`${arabic ? 'arFont' : ''} mx-2 blue--text`">{{i18n.forgetPassword}}</span>
            <span v-if="forgetpass" 
              @click="forgetpass  = false" 
              style="cursor:pointer;font-size:12px;" 
              :class="`${arabic ? 'arFont' : ''} mx-2 blue--text`">{{i18n.login}}</span>
            <v-spacer></v-spacer>
            <v-btn color="primary" v-if="!forgetpass" @click="()=>{login_screen=false;register_screen=true;forgetpass=false}" text large :loading="loading" 
              :class="`${arabic?'arFont':'enFont'}`">
              {{i18n.register}}
            </v-btn>
            <v-btn color="primary" v-if="!forgetpass" @click="login" large :loading="loading" 
              :class="`${arabic?'arFont':'enFont'}`">
              {{i18n.login}}
            </v-btn>
            <v-btn v-if="forgetpass" color="primary" @click="resetPass" :loading="loading" 
              :class="`${arabic ? 'arFont' : ''}`">
              {{i18n.sendResetEmail}}
            </v-btn>
          </v-card-actions>
          <v-card-actions v-if="false" OLD>
            <v-spacer></v-spacer>
            
            <v-btn color="primary" v-if="!forgetpass" text large :loading="loading" 
              @click="()=>{login_screen=true;register_screen=false}"
              :class="`${arabic?'arFont':'enFont'}`">
              {{i18n.login}}
            </v-btn>
            <v-btn color="primary" :disabled="!terms" v-if="!forgetpass" @click="register" large :loading="loading" 
              :class="`${arabic?'arFont':'enFont'}`">
              {{i18n.register}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" md="4" class="pa-0 elevation-0 align-center">
      </v-col>
    </v-row>
  </div>
</template>

<script>
import countriesJSON from '@/countries-ash.json'
import {firebase, db, auth} from '@/fb'
import axios from 'axios';
const headers = {'Accept': 'application/json'};
import { getRandomInt, randomString, getCDate} from '@/customFunction';
const fireapi = 'https://us-central1-shark-sellers.cloudfunctions.net/main';
import Footer from '@/components/footer'

export default {
  components: { Footer },
  data: () => ({
    frameHeight:0,
    loading: false,
    login_screen:true,
    register_screen:false,
    verify_screen:false,
    verification:false,
    forgetpass:false,
    error:null,
    resetStat:null,
    errorTimeOUt:null,
    user: {
      email: null,
      password: null
    },
    session_token:null,
    sms_code:null,
    REMOVE:null,
    installed:true,
    magic:false,
    cap:false,
    captchaCheck:null,
    captcha:null,
    splash:{url:'/joobbie-3.png', cover:true, contain:false},
    splashes:[
      {url:'/joobbie-3.png', cover:false, contain:true}, 
      {url:'/joobbie-2.png', cover:false, contain:true},
      {url:'/frankfurt.jpg', cover:true, contain:false}
    ],
    terms:false,
    verify_success:false,
    firstName:null,
    lastName:null,
    countries:[],
    
    ads:[
      'none',
      'facebook_ads',
      'google_ads',
      'tiktok_ads',
      'instagram_ads',
      'snapchat_ads',
      'youtube_ads',
      'whatsapp_marketing',
      'facebook_groups_marketing',
      'facebook_market_marketing',
    ],
    sales:[
      "sales_0",
      "sales_50_to_100",
      "sales_101_to_300",
      "sales_301_to_500",
      "sales_501_to_800",
      "sales_801_to_1000",
      "sales_more_than_1000",
    ],
    budgets: [
      "ad_budget_none",
      "ad_budget_0_to_500",
      "ad_budget_501_to_1000",
      "ad_budget_1001_to_5000",
      "ad_budget_5000_to_10000",
      "ad_budget_more_than_10000",
    ],
    repeatpassword:null,
    register_step:1
  }),

  methods: {
    async submitBasicInfo() {
      if (!this.user.country_id) {
        this.error = this.i18n["residency_country_required"]
        this.resetError()
        return
      }
      if (!this.firstName) {
        this.error = this.i18n["first_name_required"]
        this.resetError()
        return
      }
      if (!this.lastName) {
        this.error = this.i18n["last_name_required"]
        this.resetError()
        return
      }
      this.user.name = this.firstName.trim() + ' ' + this.lastName.trim()
      if (!this.user.name) {
        this.error = `${this.i18n[name_required]}`
        this.resetError()
        return
      }
      if (!this.user.phone) {
        this.error = this.i18n["phone_required"]
        this.resetError()
        return
      }
      this.user.phone = await this.checkPhone(this.user.phone, this.countries.filter(x => x.id == this.user.country_id)[0])
      if (!this.user.phone) {
        this.resetError()
        return
      }
      this.register_step = 2
    },
    goTo(path) {
      this.$router.push(path)
    },
    async checkPhone(phone, country) {
      return new Promise((res, rej)=>{
        if(!phone || !country) {
          res(false)
        }
        let phoneNumber = phone
        if(phoneNumber) {
          phoneNumber = phoneNumber.replace(/[٠١٢٣٤٥٦٧٨٩]/g, function (d) {
            return d.charCodeAt(0) - 1632;                
          }).replace(/[۰۱۲۳۴۵۶۷۸۹]/g, function (d) { return d.charCodeAt(0) - 1776; })
        }

        let calling_code = countriesJSON.filter(x=>x.alpha2Code == country.alpha2Code)[0].callingCodes[0]
        let check_phone = phoneNumber
        if(!phoneNumber.startsWith(calling_code)) {
          check_phone = `${calling_code}${phoneNumber}`
        }

        
        return axios.get(`https://us-central1-ashyaatcrm.cloudfunctions.net/ash_phone/vPhone?phone=${encodeURI(check_phone)}&cc=${country.alpha2Code}`)
        .then(resp=>{
          if(resp.data.corrected && resp.data.g && resp.data.g.isValidNumber) {
            res(resp.data.corrected ? resp.data.corrected : phoneNumber)
          } else {
            this.error = this.i18n['enter_correct_phone_number']
            res(false)
          }
        })
      })
    },
    async resetPass(){
      this.loading = true
      // console.log(this.user)
      let r = await axios.post(`${fireapi}/resetPassword`, this.user, {headers}).then(x=>x.data)
      if(r.success) {
        this.$emit('snackbarNotification', this.i18n['email_sent'], 'success')
        this.forgetpass = false
      }
      // console.log(r)
      this.loading = false
    },
    setCookie(name, value, days) {
      var expires = "";
      var maxAge = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
        maxAge = "; max-age=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    },
    getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    },
    async localLogin(e) {
      let r = await axios.post(`${this.api}/user/login`, {email:e, sec:process.env.VUE_APP_SEC}, {headers}).then(x=>x.data)
      if(!r.error) {
        this.loading = false
        this.$store.state.centralLogin = true
        this.$store.state.access_token = r.access_token
        this.setCookie('_MJC', r.access_token, 1)
        this.$store.state.user = r.user
        if(r.user && r.user.role == 'admin')  {
          this.goTo('/dashboard')
        } else if(r.user && r.user.role == 'superadmin')  {
          this.goTo('/dashboard')
        } else if (r.user && r.user.role == 'business') {
          this.goTo('/reports')
      }  else {
          this.goTo('/dashboard')
        }
      }
    },
    async login() {
      this.loading = true;
      // let cap = await this.capcha()
      let e = this.user.email
      let p = this.user.password
      // if(!cap) {
      //   this.loading = false;
      //   this.error = `يرجى المحاولة لاحقا او التواصل مع الدعم`
      //   this.resetError()
      //   return true
      // }
      if(!e){
        this.loading = false;
        this.error = `${this.i18n[email_required]}`
        this.resetError()
        return true
      }
      if(!p){
        this.loading = false;
        this.error = `${this.i18n[password_required]}`
        this.resetError()
        return true
      }
      if(process.env.VUE_APP_VARS && process.env.VUE_APP_VARS === 'local') {
        this.localLogin(e)
        return;
      }
      firebase.auth().signInWithEmailAndPassword(e, p).then(
        (resp) => {
          // console.log('resp', resp)
          this.Auth(resp.user.ma)
        },
        async (err) => {
          // console.log(err)
          this.loading = false;
          console.log(err)
          if (err.code == 'auth/wrong-password') {
            this.error = this.i18n['email_or_password_is_wrong']
          } else if(err.code == 'auth/user-not-found') {
            // User Not Found
            this.error = `${this.i18n["user_not_found"]}`
          }
          this.resetError()
        }
      );
    },
    OauthLogin(p) {
      this.loading = true
      var provider
      switch (p) {
        case 0:
          provider = new firebase.auth.GoogleAuthProvider();
          break;
        default:
          break;
      }
      firebase.auth().signInWithPopup(provider).then(async (u) => {
        console.log(u)
        let a = u.additionalUserInfo
        let n = a.profile
        let check = await this.userCheck(u.user.email)
        if (!check && this.user.phone) {
          let nu = {
            'provider': u.user.providerData[0].providerId,
            'name': u.user.displayName,
            'email': u.user.email,
            'phone': this.user.phone,
            'country_id': this.user.country_id,
            'image': u.user.photoURL,
            'verified_email': u.user.emailVerified,
            'uid': u.user.uid,
            'ads': this.user.ads,
            'sales': this.user.sales,
            'whatsapp': this.user.whatsapp,
            'facebook_link': this.user.facebook_link,
            'countries_history':this. user.countries_history,
            'current_budget': this.user.current_budget,
            'time_to_call': this.user.time_to_call,
            'origin': window.location.hostname
          }
          await this.userUpdate(nu, u.user.ma)
          this.loading = false
        } else if(check) {
          this.Auth(u.user.ma)
        } else {
          this.$emit('snackbarNotification', this.i18n['please_register_before_login'], 'error')
          this.loading = false

        }
      })
        .catch((error) => {
          this.error = error.message
          console.log(this.error)
          this.loading = false
          this.$emit('snackbarNotification', `Error`, 'error')
          this.resetError()
        });
    },
    async Auth(token){
      let r = await axios.post(`${fireapi}/loginUser`, {token}, {headers}).then(x=>x.data)
      if(!r.error) {
        this.loading = false
        this.$store.state.centralLogin = true
        this.$store.state.access_token = r.access_token
        this.setCookie('_MJC', r.access_token, 1)
        this.$store.state.user = r.user
        if(r.user && r.user.role == 'admin')  {
          this.goTo('/dashboard')
        } else if(r.user && r.user.role == 'superadmin')  {
          this.goTo('/dashboard')
        } else if (r.user && r.user.role == 'business') {
          this.goTo('/reports')
      }  else {
          this.goTo('/dashboard')
        }
      } else if (r.error == 'unuthorized_access') {
        this.loading = false
        this.$emit('snackbarNotification', `${this.i18n.accountCreated}`, 'error')
        this.error = this.i18n.accountCreated
        this.resetError()
      } else {
        this.loading = false
        this.$emit('snackbarNotification', `${r.error}`, 'error')
        this.error = r.error
        this.resetError()
      }
    },
    async getCurrentUser(){
      firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(function(idToken) {
        // Send token to your backend via HTTPS
        // console.log(idToken)
        
      }).catch(function(error) {
        // Handle error
      });
      this.loading = false;
    },
    async capcha() {
      return new Promise(async (res, rej)=>{
        return res(true)
        grecaptcha.ready(function() {
          grecaptcha.execute('6LdupMIhAAAAAA6YmNGXnvJr5Lb8lIfisR_SRVeZ', {action: 'submit'}).then( async (token) => {
              let r = await axios.post(`https://yervip.com/api/v1/capcheck`, {token}).then(x=>x.data)
              if(r.success && r.score > 0.2) {
                res(true)
              } else {
                res(false)
              }
          });
        });
      })
    },
    async userCheck(email) {
      return new Promise(async (res, rej) => {
        let r = await axios.post(`${this.api}/check-user`, { email }, headers).then(x => x.data)
        // console.log(r);
        if (r.exists) {
          res(true)
        } else {
          res(false)
        }
      })
    },
    async userUpdate(nu, social_token = null) {
      return new Promise(async (res, rej)=>{
        let r = await axios.post(`${this.api}/user`, nu, headers).then(x => x.data)
        // console.log(r);
        if (!r.error) {
          this.$emit('snackbarNotification', this.i18n['account_created_logining_in'], 'success')
        }
        if(!social_token) {
          this.login()
          res(true)
        } else {
          this.Auth(social_token)
          res(true)
        }
      })
    },
    async registeration(user) {
      try {
        let a = await axios.post(`${fireapi}/registerNewUser`, user, { headers: headers }).then(x => x.data)
        // console.log(a)

        if (!a.error) {
          this.loading = false;
          this.error = null
          let nu = {
            'provider': a.user.providerData[0].providerId,
            'name': a.user.displayName,
            'email': a.user.email,
            'phone': user.phone,
            'country_id': user.country_id,
            'image': a.user.photoURL,
            'verified_email': a.user.emailVerified,
            'uid': a.user.uid,
            'ads': user.ads,
            'sales': user.sales,
            'whatsapp': user.whatsapp,
            'facebook_link': user.facebook_link,
            'countries_history': user.countries_history,
            'current_budget': user.current_budget,
            'time_to_call': user.time_to_call,
            'origin': window.location.hostname
          }
          this.userUpdate(nu)
        } else {
          this.error = `${this.i18n[a.error.message] ? this.i18n[a.error.message] : a.error.message}`
          if (this.error == `user_exists_login`) {
            this.login_screen = true
            this.register_screen = false
            this.forgetpass = false
          }
          this.resetError()
          this.loading = false;
        }
      } catch (error) {
        // console.log(error);
      }
    },
    async register () {
      // let cap = await this.capcha()
      // if(!cap) {
      //   this.loading = false;
      //   this.error = `يرجى المحاولة لاحقا او التواصل مع الدعم`
      //   this.resetError()
      //   return true
      // }
      if (!this.repeatpassword){
        this.error = this.i18n['please_confirm_password']
        this.resetError()
        return
      }
      if (this.repeatpassword != this.user.password){
        this.error = this.i18n['confirm_password_not_matching']
        this.resetError()
        return
      }
      if(!this.user.country_id) {
        this.error = this.i18n['residency_country_required']
        this.resetError()
        return
      }
      if(!this.firstName) {
        this.error = this.i18n['first_name_required']
        this.resetError()
        return
      }
      if(!this.lastName) {
        this.error = this.i18n['last_name_required']
        this.resetError()
        return
      }
      this.user.name = this.firstName.trim() + ' ' + this.lastName.trim()
      if(!this.user.name) {
        this.error = this.i18n['name_required']
        this.resetError()
        return
      }
      if(!this.user.email) {
        this.error = this.i18n['email_required']
        this.resetError()
        return
      }
      if(!this.user.phone) {
        this.error = this.i18n['phone_required']
        this.resetError()
        return
      }
      if(!this.user.password) {
        this.error = `${this.i18n["password_required"]}`
        this.resetError()
        return
      }
      
      if(!this.terms) {
        this.error = this.i18n['terms_acceptance_required']
        this.resetError()
        return
      }
      this.user.phone = await this.checkPhone(this.user.phone, this.countries.filter(x=> x.id == this.user.country_id)[0])
      if(!this.user.phone) {
        this.resetError()
        return
      }
      this.loading = true;
      this.registeration(this.user)
      // user.countries_history = this.user.countries_history.join(', ')
      // user.ads = this.user.ads.join(', ')
      
    },
    resetError(){
      clearTimeout(this.errorTimeOUt)
      this.errorTimeOUt = setTimeout(x=>{ this.error = null }, 4000)
    },
    enLanguage(){
      this.$emit('changeLang', 'en')
    },
    arLanguage(){
      this.$emit('changeLang', 'ar')
    },
    switchLanguage(l) {
      this.$store.state.language = l
      if(l=='ar') {
        this.$vuetify.rtl = true
      } else {
        this.$vuetify.rtl = false
      }
      this.getSplash()
    },
    setH(){
      let h = window.innerHeight
        || document.documentElement.clientHeight
        || document.body.clientHeight;
      this.frameHeight = h + (this.register_screen ? 900 : 150)
    },
    getSplash(){
      let a = getRandomInt(0, this.splashes.length-1)
      // console.log(a)
      this.splash = this.splashes[a]
    },
    async verifyEmail(){
      return new Promise(async (res, rej)=>{
        this.loading = true
        let a = await this.$store.dispatch('getResource', {resource:`/verify/${this.$route.params.hash}`})
        // console.log(a)
        this.verify_success = a.success
        this.loading = false
      })
    },
    async getAction(){
      if(this.$route.name == 'login') {
        this.login_screen = true
        this.register_screen = false
        this.verify_screen = false
      } else if (this.$route.name == 'register') {
        this.login_screen = false
        this.register_screen = true
        this.verify_screen = false
      } else if (this.$route.name == 'verify'){
        this.login_screen = false
        this.register_screen = false
        this.verify_screen = true
        await this.verifyEmail()
      }
    },
    async init(){
      return new Promise(async(res, rej)=>{
        this.getSplash()
        this.getAction()
        this.countries.push({name:this.i18n['not_found'], 'id': 0})
        let a = await axios.get(`https://product.yervip.com/api/v1/countries-all`).then(x=>x.data)
        this.countries.push(...a.slice(1, a.length))
        res(true)
      })
    }
  },
  props: {
    
  },
  watch:{
    api(){},
    $route (to, from){
      this.getAction()
      this.setH()
    },
    register_screen(){ this.setH() },
    login_screen(){ this.setH() },
    verify_screen(){ this.setH() },
  },
  computed:{
    countries_ar() {
      return this.$store.state.countries_ar
    },
    calculatedframeHeight(){
      let h = window.innerHeight
        || document.documentElement.clientHeight
        || document.body.clientHeight;
      return h + this.register_screen ? 600 : 300
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    api(){
      return this.$store.state.settings.apiBase
    }
  },
  async created(){
    
    await this.init()
  },
  mounted(){
    this.setH()
  }

};
</script>
<style scoped lang="css">
  #login {
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
  }
</style>
